"use strict"

import { knowledgebaseInstance as API } from "@/plugins/hylable-sdk"

export default {
  async searchSpeaker({oid, did, start, end}){
    return API.post(`/speaker/${oid}/search`, {did, start, end})
  },
  async indexSpeaker({oid, did, mid, start, end}){
    return API.post(`/speaker/${oid}/index`, {did, mid, start, end})
  },
  async deleteSpeaker({oid, did, mid, start, end}){
    return API.post(`/speaker/${oid}/delete`, {did, mid, start, end})
  },
}
